module.exports = __webpack_public_path__ + "static/media/Viloham Immediate Suspension Order_Redacted.5920488e.pdf";